import type { PropsWithChildren } from "react";

export const FeatureList = ({ children }: PropsWithChildren<object>) => (
  <ul className="flex list-none flex-col gap-y-4">{children}</ul>
);
